require.config({
    config: {
        'handsontable.licensed': { //nel file "handsontable.licensed.js", si potr� ottenere la licenseKey col comando "module.config().licenseKey"
            hansontableLicenseKey: "976e5-c2357-deec5-e4a1e-efa4e"
        }
    },
    waitSeconds : 30,
    baseUrl: "base",
    paths: {
        'components': '../components',
        'modules': '../modules',
        'uiscreens': '../uiscreens',
        'content': '../Content',
        'd3': '../scripts/d3.min',
        "jquery": "../scripts/jquery-3.1.1.min",
        "vue": "../scripts/Vue.min",
        "dompurify": "../scripts/purify.min",
        // "vue": "../scripts/Vue",
        "sortablejs": "../scripts/Sortable-1.6.0.min",
        "vuedraggable": "../scripts/vuedraggable-2.14.1.min",
        "text": "../scripts/requirejs-text-2.0.15",
        "promise": "../scripts/requirejs-promise",
        "json": "../scripts/requirejs-json",
        "cookie": "../scripts/jquery.cookie",
        "underscore": "../scripts/underscore-umd-min",
        "sammy": "../scripts/sammy-0.7.5.min",
        "bootstrap": "../scripts/bootstrap.min",
        "datepicker": "../scripts/bootstrap-datepicker.min",
        "datetimepicker": "../scripts/bootstrap-datetimepicker.min",
        "handlebars": "../scripts/handlebars.min-v4.7.8",
        "adal": "../scripts/adal-1.0.13.min",
        "msal-browser": "../scripts/msal-browser.min",
        "notify": "../scripts/bootstrap-notify",
        "datatables.net": "../scripts/jquery.dataTables.min",
        "datatables-bootstrap": "../scripts/dataTables.bootstrap",
        "file-saver": "../scripts/FileSaver.min",
        "blob": "../scripts/Blob",
        "highlight": "../scripts/highlight.pack",
        "EventEmitter": "../scripts/EventEmitter.min",
        "clipboard": "../scripts/clipboard.min",
        "datagrid": "../components/datagrid",
        "honeypot": "../components/honeypot",
        "notifications":"../components/notifications",
        "seriesItemsEditor": "../components/seriesItemsEditor",
        "invoiceItemsEditor": "../uiscreens/invoiceItemsEditor",
        "curveCalculator": "../components/curveCalculator",
        "formulaExecutor": "../components/formulaExecutor",
        "beeLibraryDownloader": "../components/beeLibraryDownloader",
        "dealEvaluator": "../components/dealEvaluator",
        "functionExecutor": "../components/functionExecutor",
        "moment": "../scripts/moment.min",
        "pikaday": "../scripts/handsontable/lib/pikaday.min",
        "numbro": "../scripts/handsontable/lib/numbro.min",
        "hot-formula-parser": "../scripts/handsontable/lib/formula-parser",
        "tiny-emitter": "../scripts/handsontable/lib/tiny-emitter",
        "formula": "../scripts/handsontable/lib/formula",
        "jstat": "../scripts/handsontable/lib/jstat",
        "bessel": "../scripts/handsontable/lib/bessel",
        "voc": "../scripts/handsontable/lib/voc",
        //"Handsontable": "../scripts/handsontable/ce/handsontable",
        "Handsontable": "../scripts/handsontable/pro/handsontable",
        //"handsontable.vue": "../scripts/handsontable/ce/vue-handsontable",
        "handsontable.licensed": "../scripts/handsontable/handsontable.licensed",
        "handsontable.vue": "../scripts/handsontable/pro/vue-handsontable",
        "handsontableSelect2Editor": "../components/handsontableSelect2Editor",
        "handsontable.utility": "../components/handsontable.utility",
        "dropdown": "../components/dropdown",
        "select": "../components/select",
        "toolbar.vue": "../components/toolbar.vue",
        "searchFilter.vue": "../components/searchFilter.vue",
        "select2.vue": "../components/select2.vue",
        "datepicker.vue": "../components/datepicker.vue",
        "datetimepicker.vue": "../components/datetimepicker.vue",
        "form": "../components/form",
        "form.mixins.vue": "../components/form.mixins.vue",
        "modal-code": "../components/modal-code",
        "modal.vue": "../components/modal.vue",
        "modal.content.vue": "../components/modal.content.vue",
        "dashboard": "../uiscreens/dashboard",
        "parsley": "../scripts/parsley.min",
        "typeahead": "../components/typeahead",
        //"select2": "../scripts/select2-4.0.3.full",
        //"select2": "../scripts/select2-4.0.6-rc.1.full",
        "select2": "../scripts/select2-4.0.5.full.min",
        "jquery-typeahead": "../scripts/jquery.typeahead",
        "jquery-confirm": "../scripts/jquery.confirm", //https://github.com/tonypolik/jquery.confirm
        "jquery-highlight": "../scripts/jquery.highlight",
        "baseOdataModule": "../modules/baseOdataModule",
        "logs_view": "../uiscreens/logs",
        "logs": "../modules/logs",
        "massDealLoaderJobs_view": "../uiscreens/massDealLoaderJobs",
        "massDealLoaderJobs": "../modules/massDealLoaderJobs",
        "products_view": "../uiscreens/products",
        "products": "../modules/products",
        "markets_view": "../uiscreens/markets",
        "markets": "../modules/markets",
        "calendar_view": "../uiscreens/calendar",
        "series_view": "../uiscreens/series",
        "series": "../modules/series",
        "seriesItems": "../modules/seriesItems",
        "queryBuilder_view": "../uiscreens/queryBuilder",
        "queryBuilder": "../components/queryBuilder",
        "queryBuilderReferencedJobs": "../uiscreens/queryBuilderReferencedJobs",
        "queries": "../modules/queries",
        "unitofmeasures_view": "../uiscreens/unitofmeasure",
        "unitofmeasures": "../modules/unitofmeasures",
        "currencies": "../modules/currencies",
        "currencies_view": "../uiscreens/currencies",
        "currenciesConversions": "../modules/currenciesConversions",
        "commodities": "../modules/commodities",
        "commodities_view": "../uiscreens/commodities",
        "sources_view": "../uiscreens/sources",
        "sources": "../modules/sources",
        "recycleBin_view": "../uiscreens/recycleBin",
        "calendars": "../modules/calendars",
        "scriptLoader_view":"../uiscreens/scriptLoader",
        "formulae": "../modules/formulae",
        "formulae_view": "../uiscreens/formulae",
        "formulaParameters": "../modules/formulaParameters",
        "formulaParameters_view": "../uiscreens/formulaParameters",
        "orchestrator": "../modules/orchestrator",
        "orchestrator_view": "../uiscreens/orchestrator",
        "jobstree.viewer.vue": "../components/jobstree.viewer.vue",
        "matrix": "../uiscreens/matrix",
        "matrixConfiguration": "../uiscreens/matrixConfiguration",
        "honeypotInputAddOn": "../components/honeypotInputAddOn",
        "honeypotElements": "../modules/honeypotElements",
        "viewFormulaAddOn": "../components/viewFormulaAddOn",
        "checkNamesAddOn": "../components/checkNamesAddOn",
        "codeGeneratorAddOn": "../components/codeGeneratorAddOn",
        "jobAdvancedSchedulingAddOn": "../components/jobAdvancedSchedulingAddOn",
        "portfolio-tree": "../components/portfolio-tree",
        "portfolio": "../uiscreens/portfolio",
        "portfolioFolder": "../uiscreens/portfolioFolder",
        "portfolioDetails": "../uiscreens/portfolioDetails",
        "counterparties_view": "../uiscreens/counterparty",
        "counterparty.masteragreement.tab": "../uiscreens/counterparty.masterAgreement",
        "counterparty.creditdata.tab": "../uiscreens/counterparty.creditData",
        "counterparty.contact.tab": "../uiscreens/counterparty.contact",
        "counterparty.businessunit.tab": "../uiscreens/counterparty.businessUnit",
        "counterparty.externalcode.tab": "../uiscreens/counterparty.externalCode",
        "counterparty.creditlimit.tab": "../uiscreens/counterparty.creditLimit",
        "counterparty.warranty.tab": "../uiscreens/counterparty.warranty",
        "counterparty.exposure.tab": "../uiscreens/counterparty.exposure",
        "counterparty.attachment.tab": "../uiscreens/counterparty.attachment",
        "counterparty.account.tab": "../uiscreens/counterparty.account",
        "counterparty.counterpartyEvent.tab": "../uiscreens/counterparty.counterpartyEvent",
        "agreementTypes_view": "../uiscreens/agreementType",
        "portfolioItems": "../modules/portfolioItems",
        "deals": "../modules/deals",
        "dealStatuses": "../modules/dealStatuses",
        "dealStatuses.invoiceitems": "../modules/dealStatuses.invoiceitems",
        "statusesOwners": "../modules/statusesOwners",
        "dealModels": "../modules/dealModels",
        "dealPresets": "../modules/dealPresets",
        "dealEvents": "../modules/dealEvents",
        "accordion": "../components/accordion",
        "accordion.vue": "../components/accordion.vue",
        "tabs": "../components/tabs",
        "dealcapture_view": "../uiscreens/dealcapture",
        "dealModels_view": "../uiscreens/dealModels",
        "dealParameters": "../modules/dealParameters",
        "portfolioTempFiles": "../uiscreens/portfolioTempFiles",
        "dealTemplates_view": "../uiscreens/dealTemplates",
        "productComposer": "../uiscreens/productComposer",
        "profileComposer": "../uiscreens/profileComposer",
        "dealcaptureDealEvents": "../uiscreens/dealcaptureDealEvents",
        "curveCalculatorInputAddOn": "../components/curveCalculatorInputAddOn",
        "formulaExecutorInputAddOn": "../components/formulaExecutorInputAddOn",
        "forager": "../modules/forager",
        "forager_view": "../uiscreens/forager",
        "beedrive": "../modules/beedrive",
        "beedrive_view": "../uiscreens/beedrive",
        "massiveDealsLoader_view": "../uiscreens/massiveDealsLoader",
        "massiveDealsEvents_view": "../uiscreens/massiveDealsEvents",
        "publicoffers": "../modules/publicoffers",
        "publicoffers_view": "../uiscreens/publicoffers",
        "pricings": "../modules/pricings",
        "treeView": "../components/treeView",
        "auth": "../modules/auth",
        "profile": "../modules/profile",
        "profiles": "../modules/profiles",
        "profileInfo_view": "../uiscreens/profileInfo",
        "profiles_view": "../uiscreens/profiles",
        "jobAdvancedScheduling_view": "../uiscreens/jobAdvancedScheduling",
        "groups": "../modules/groups",
        "groupsAddMember_view": "../uiscreens/groupsAddMember",
        "groups_view": "../uiscreens/groups",
        "appRoles": "../modules/appRoles",
        "appRolesAddMember_view": "../uiscreens/appRolesAddMember",
        "appRoles_view": "../uiscreens/appRoles",
        "functionsInRolesAndGroups": "../modules/functionsInRolesAndGroups",
        "functionsInRolesAndGroups_view": "../uiscreens/functionsInRolesAndGroups",
        "menuItemsInRolesAndGroups": "../modules/menuItemsInRolesAndGroups",
        "menuItemsInRolesAndGroups_view": "../uiscreens/menuItemsInRolesAndGroups",
        "entityFieldsInRolesAndGroups": "../modules/entityFieldsInRolesAndGroups",
        "entityFieldsInRolesAndGroups_view": "../uiscreens/entityFieldsInRolesAndGroups",
        "entityFieldsStatus": "../modules/entityFieldsStatus",
        "entityFieldsStatus_view": "../uiscreens/entityFieldsStatus",
        "functions": "../modules/functions",
        "legalentities": "../modules/legalEntities",
        "agreementtypes": "../modules/agreementTypes",
        "counterparties": "../modules/counterparties",
        "counterparties.creditdata": "../modules/counterparties.creditdata",
        "counterparties.contacts": "../modules/counterparties.contacts",
        "counterparties.counterpartyEvents": "../modules/counterparties.counterpartyEvents",
        "counterparties.businessunits": "../modules/counterparties.businessunits",
        "counterparties.externalcodes": "../modules/counterparties.externalcodes",
        "counterparties.creditlimits": "../modules/counterparties.creditlimits",
        "counterparties.warranties": "../modules/counterparties.warranties",
        "counterparties.masteragreements": "../modules/counterparties.masteragreements",
        "counterparties.exposures": "../modules/counterparties.exposures",
        "counterparties.attachments": "../modules/counterparties.attachments",
        "counterparties.accounts": "../modules/counterparties.accounts",
        "dealModels.manager": "../uiscreens/dealModels.manager",
        "transcodings_view": "../uiscreens/transcodings",
        "transcodings": "../modules/transcodings",
        "transcodings.priceformula": "../uiscreens/transcodings.priceformula",
        "invoiceitems_view": "../uiscreens/invoiceitems",
        "invoiceitems": "../modules/invoiceitems",
        "dealEMIRs": "../modules/dealEMIRs",
        "dealREMITs": "../modules/dealREMITs",
        "dealMIFIDs": "../modules/dealMIFIDs",
        "dealSchedulings": "../modules/dealSchedulings",
        "areas": "../modules/areas",
        "areas_view": "../uiscreens/areas",
        "deliveryPoints": "../modules/deliveryPoints",
        "deliveryPoints_view": "../uiscreens/deliveryPoints",
        "gridOperators": "../modules/gridOperators",
        "gridOperators_view": "../uiscreens/gridOperators",
        "remis": "../modules/remis",
        "remis_view": "../uiscreens/remis",
        "dealAttachments": "../modules/dealAttachments",
        "dealAttachments_view": "../uiscreens/dealAttachments",
        "dealConfirmations": "../modules/dealConfirmations",
        "itemssubmissions": "../modules/itemssubmissions",
        "itemssubmissions.form": "../uiscreens/itemssubmissions.form",
        "schedulingpce": "../modules/schedulingpce",
        "schedulingpceconfig": "../modules/schedulingpceconfig",
        "schedulingpce_view": "../uiscreens/schedulingpce",
        "schedulingdetails": "../modules/schedulingdetails",
        "schedulingdetails_view": "../uiscreens/schedulingdetails",
        "gasstorages": "../modules/gasstorages",
        "gasstorages_view": "../uiscreens/gasstorages",
        "gasnomines": "../modules/gasnomines",
        "gasnomines_view": "../uiscreens/gasnomines",
        "gashourlynomines": "../modules/gashourlynomines",
        "gashourlynomines_view": "../uiscreens/gashourlynomines",
        "itemssubmissions.import.emirremit": "../uiscreens/itemssubmissions.import.emirremit",
        "schedulingpce.import": "../uiscreens/schedulingpce.import",
        "enums": "../modules/enums",
        "bidEvo": "../components/bidEvo",
        "exportDeals": "../components/exportDeals",
        "scenarios.vue": "../uiscreens/scenarios.vue",
        "scenarios": "../modules/scenarios",
        "tabs.vue": "../components/tabs.vue",
        "tab.vue": "../components/tab.vue",
        "itemssubmissions.import.deals.vue": "../components/itemssubmissions/itemssubmissions.import.deals.vue",
        "schedulingpce.import.deals.vue": "../components/schedulingpce/schedulingpce.import.deals.vue",
        "confirmation": "../uiscreens/confirmation/confirmation",
        "confirmation.signManager.vue": "../uiscreens/confirmation/confirmation.signManager.vue",
        "confirmation.import.vue": "../uiscreens/confirmation/confirmation.import.vue",
        "confirmation.itemsSubmissionsECM.vue": "../uiscreens/confirmation/itemsSubmissionsECM.vue",

        "pdescheduling": "../uiscreens/pdescheduling/pdescheduling",
        "pdescheduling.import.vue": "../uiscreens/pdescheduling/pdescheduling.import.vue",
        "pdescheduling.pdeschedulingECM.vue": "../uiscreens/pdescheduling/pdeschedulingECM.vue",
        "pdescheduling.import.deals.vue": "../components/pdescheduling/pdescheduling.import.deals.vue",
        "pdeschedulingmodule": "../modules/pdescheduling",

        "SignManagerLite": "../uiscreens/confirmation/SignManagerLite",
        "SignManagerLite.vue": "../uiscreens/confirmation/SignManagerLite.vue",
        "ERPUsers_view": "../uiscreens/ERP/ERPUsers",
        "ERPUsers": "../modules/ERPUsers",
        "ERPLegalEntities_view": "../uiscreens/ERP/ERPLegalEntities",
        "ERPLegalEntities": "../modules/ERPLegalEntities",
        "ERPCounterparties_view": "../uiscreens/ERP/ERPCounterparties",
        "ERPCounterparties": "../modules/ERPCounterparties",
        "ERPItems_view": "../uiscreens/ERP/ERPItems",
        "ERPItems": "../modules/ERPItems",
        "ERPItemsAssocRules_view": "../uiscreens/ERP/ERPItemsAssocRules",
        "ERPItemsAssocRules": "../modules/ERPItemsAssocRules",
        "ERPOrderItems_view": "../uiscreens/ERP/orderItems",
        "orderItemsManager.vue": "../uiscreens/ERP/orderItemsManager.vue",
        "orderItemsNew.vue": "../uiscreens/ERP/orderItemsNew.vue",
        "ERPorderItems": "../modules/ERPOrderItems",
        "ERPorders": "../modules/ERPOrders",
        "ERPMessages_view": "../uiscreens/ERP/ERPMessages",
        "ERPMessages": "../modules/ERPMessages",
        "querycounts_view": "../uiscreens/querycounts",
        "querycounts": "../modules/querycounts",
        "querycategories_view": "../uiscreens/querycategories",
        "querycategories": "../modules/querycategories",
        "trayport.configuration.vue": "../uiscreens/trayport/trayport.configuration.vue",
        "trayport.mappingRules.vue": "../uiscreens/trayport/mappingRules.vue",
        "trayport.mappingRules.form.vue": "../uiscreens/trayport/mappingRules.form.vue",
        "trayport.mappingRules": "../modules/trayport.mappingRules",
        "trayport.instDefinitions": "../modules/trayport.instDefinitions",
        "trayport.monitor.vue": "../uiscreens/trayport/trayport.monitor.vue",
        "trayport.failedImports": "../modules/trayport.failedImports",
        "trayport.rollingProducts.vue": "../uiscreens/trayport/rollingProducts.vue",
        "trayport.rollingProducts.form.vue": "../uiscreens/trayport/rollingProducts.form.vue",
        "trayport.rollingProducts": "../modules/trayport.rollingProducts",
        "trayport.sequences": "../modules/trayport.sequences",
        "trayport.sequenceItems": "../modules/trayport.sequenceItems",
        "trayport.internalMarket.vue": "../uiscreens/trayport/trayport.internalMarket.vue",
        "trayport.brokers.vue": "../uiscreens/trayport/brokers.vue",
        "trayport.brokers.form.vue": "../uiscreens/trayport/brokers.form.vue",
        "trayport.companies.vue": "../uiscreens/trayport/companies.vue",
        "trayport.companies.form.vue": "../uiscreens/trayport/companies.form.vue",
        "trayport.hedges.vue": "../uiscreens/trayport/hedges.vue",
        "trayport.hedges.form.vue": "../uiscreens/trayport/hedges.form.vue",
        "trayport.brokers": "../modules/trayport.brokers",
        "trayport.companies": "../modules/trayport.companies",
        "trayport.hedges": "../modules/trayport.hedges",
        "trackProcesses": "../modules/EnBO/trackProcesses",
        "trackActivities": "../modules/EnBO/trackActivities",
        "flowsMonitor_view": "../uiscreens/EnBO/flowsMonitor",
        "processesMonitor_view": "../uiscreens/EnBO/processesMonitor",
        "dealsDashboard.vue": "../uiscreens/dealsDashboard/dealsDashboard.vue",
        // testing libraries
        "squire": "../scripts/Squire",
        "vue-test-utils": "../node_modules/vue-test-utils/dist/vue-test-utils.amd",
        "vue-template-compiler": "../node_modules/vue-template-compiler/browser",
        "dealStatusesManager_view": "../uiscreens/DealStatusesManager",
        "approvalManager_view": "../uiscreens/ApprovalManager",
        "entityHistory_view": "../uiscreens/entityHistory",
        "changesetDetails": "../modules/changesetDetails"
    },
    map: {
        "*": {
            'handsontable': 'handsontable.licensed', //require('handsontable') equivarr� a scrivere require('handsontable.licensed')
            'handsontable-pro': 'handsontable.licensed'
        }
    },
    shim: {
        "bootstrap": { "deps": ["jquery"] },
        "datepicker": { "deps": ["bootstrap"] },
        "datetimepicker": { "deps": ["bootstrap"] },
        "sammy": { "deps": ["jquery"] },
        "parsley": { "deps": ["jquery"] },
        "adal":
            {
                exports: "AuthenticationContext"
            },
        "notify": { "deps": ["jquery", "bootstrap"] },
        "datatables.net": {
            "deps": ["jquery"]
        },
        "datatables-bootstrap": {
            "deps": ["jquery", "datatables.net", "bootstrap"]
        },
        "typeahead": { "deps": ["jquery", "jquery-typeahead"] },

        "logs_view": { "deps": ["logs", "entities"] },
        "products_view": { "deps": ["products", "entities"] },
        "formulae_view": { "deps": ["file-saver", "blob"] },
        "scriptLoader_view": { "deps": ["file-saver", "blob"] },
        "dealParameters": { "deps": ["file-saver", "blob"] },
        "honeypot": { "deps": ["file-saver", "blob"] },
        "portfolio": { "deps": ["jquery", "jquery-highlight", "jquery-confirm"] },
        "jquery-confirm": { "deps": ["jquery"] },
        "treeView" : { "deps": ["jquery"] },
        "vuedraggable": { "deps": ["sortablejs"] },
    }
});
require.config({ urlArgs: "v=1734511425299" })